import { render, staticRenderFns } from "./DashboardTabSales.vue?vue&type=template&id=7a71cfe0&scoped=true&"
import script from "./DashboardTabSales.vue?vue&type=script&lang=js&"
export * from "./DashboardTabSales.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTabSales.vue?vue&type=style&index=0&id=7a71cfe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a71cfe0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
